import React from 'react';
import './footer.css';
import { FiGithub, FiLinkedin, FiMail, FiArrowUp } from 'react-icons/fi';
import { SiUpwork, SiFiverr } from 'react-icons/si';
import { profile } from '../../data/profile';

const links = [
  { href: '#about', label: 'About' },
  { href: '#focus', label: 'Focus' },
  { href: '#experience', label: 'Experience' },
  { href: '#skills', label: 'Skills' },
  { href: '#contact', label: 'Contact' },
];

const socials = [
  { href: profile.github, label: 'GitHub', icon: <FiGithub /> },
  { href: profile.linkedin, label: 'LinkedIn', icon: <FiLinkedin /> },
  { href: profile.upwork, label: 'Upwork', icon: <SiUpwork /> },
  { href: profile.fiverr, label: 'Fiverr', icon: <SiFiverr /> },
  { href: `mailto:${profile.email}`, label: 'Email', icon: <FiMail /> },
];

const Footer = () => (
  <footer className="site-footer">
    <div className="container site-footer__inner">
      <div className="site-footer__brand">
        <a href="#home" className="site-footer__logo">
          fantahun<span className="text-gradient">.dev</span>
        </a>
        <p>{profile.role}</p>
        <p className="mono site-footer__loc">
          {profile.location} · {profile.timezone}
        </p>
      </div>

      <nav className="site-footer__links" aria-label="Footer">
        {links.map((link) => (
          <a key={link.href} href={link.href}>
            {link.label}
          </a>
        ))}
      </nav>

      <div className="site-footer__socials">
        {socials.map((social) => (
          <a
            key={social.label}
            href={social.href}
            target={social.href.startsWith('mailto:') ? undefined : '_blank'}
            rel="noreferrer"
            aria-label={social.label}
          >
            {social.icon}
          </a>
        ))}
      </div>
    </div>

    <div className="container site-footer__bar">
      <small>
        &copy; {new Date().getFullYear()} Fantahun Fekadu. Designed &amp; built from Addis Ababa.
      </small>
      <a href="#home" className="site-footer__top">
        Back to top
        <FiArrowUp />
      </a>
    </div>
  </footer>
);

export default Footer;
